import { createWebHistory, createRouter } from 'vue-router'

/* Layouts */
import Layout1 from '../layouts/Layout1'
import Default from '../layouts/BlankLayout'
import AuthLayout1 from '../layouts/AuthLayouts/AuthLayout1'
/* Dashboards View */
import Dashboard4 from '../views/Dashboards/Dashboard4'
/* Authentic View */
import SignIn1 from '../views/AuthPages/Default/SignIn1'
import SignUp1 from '../views/AuthPages/Default/SignUp1'
import RecoverPassword1 from '../views/AuthPages/Default/RecoverPassword1'
import LockScreen1 from '../views/AuthPages/Default/LockScreen1'
import ConfirmMail1 from '../views/AuthPages/Default/ConfirmMail1'
/* Extra Pages */
import ErrorPage from '../views/Pages/ErrorPage'
import ComingSoon from '../views/Pages/ComingSoon'
import Maintenance from '../views/Pages/Maintenance'
import FAQ from '../views/Pages/FAQ'
/* Apps Views */
import EmailListing from '../views/Apps/Email/EmailListing'
import EmailCompose from '../views/Apps/Email/EmailCompose'
import Calendar from '../views/Apps/Calendar/Calendar'
import ChatIndex from '../views/Apps/Chat/ChatIndex'
import ChartPage from '../views/Apps/Charts/ChartPage'
/* Patients View */
import Profile from '../views/User/Profile'
import ProfileEdit from '../views/Doctor/ProfileEdit'
import AddPatient from '../views/User/AddUser'
import UserList from '../views/User/UserList'
import firebaseProject from '../../firebase'
import PatientDashboard from '../views/User/PatientDashboard'
/* Doctor View */
import ProfileView from '../views/Doctor/ProfileView'

/* Patient Login View */
import PatientHome from '../views/Dashboards/PatientHome'
import ShopSessions from '../views/PatientViews/ShopSessions.vue'
import ShopDevices from '../views/PatientViews/ShopDevices.vue'
import ShopCoins from '../views/PatientViews/ShopCoins.vue'
import ShoppingCart from '../views/PatientViews/ShoppingCart.vue'
import OrderComfirmation from '../views/PatientViews/OrderConfirmation.vue'
import OrderHistory from '../views/PatientViews/OrderHistory.vue'
import RequestInvoiceForm from '../views/PatientViews/RequestInvoiceForm.vue'
import PatientProfile from '../views/PatientViews/PatientProfile.vue'
import PatientProfileEdit from '../views/PatientViews/PatientProfileEdit.vue'
import CreateWallet from '../views/PatientViews/CreateWallet.vue'
import ImportWallet from '../views/PatientViews/ImportWallet.vue'
import ExportWallet from '../views/PatientViews/ExportWallet.vue'
import KneeSleevePreordersSummary from '../views/PatientViews/KneeSleevePreordersSummary.vue'
import KneeSleevePreorderDetails from '../views/PatientViews/KneeSleevePreorderDetails.vue'
import KneeSleevePreorderForm from '../views/PatientViews/KneeSleevePreorderForm.vue'
import ReportBugs from '../views/PatientViews/ReportBugsForm.vue'
import ProvideFeedbackForm from '../views/PatientViews/ProvideFeedbackForm.vue'

/* Admin Login View */
import AdminHome from '../views/Admin/AdminHome.vue'
import CollectionsView from '../views/Admin/Database/CollectionsView.vue'
import DocumentDisplay from '../views/Admin/Database/DocumentDisplay.vue'
import PreOrderSummary from '../views/Admin/PreOrder/PreOrderSummary.vue'
import PreordersTable from '../views/Admin/PreOrder/PreordersTable.vue'
import PreorderDetail from '../views/Admin/PreOrder/PreorderDetail.vue'
import BugSubmissions from '../views/Admin/FormSubmissions/BugSubmissions.vue'
import FeedbackSubmissions from '../views/Admin/FormSubmissions/FeedbackSubmissions.vue'
import BugsManagementMenu from '../views/Admin/FormSubmissions/BugsManagementMenu.vue'
import BugsBacklog from '../views/Admin/FormSubmissions/BugsBacklog.vue'

/* Settings */
import MainSettings from '../views/Settings/MainSettings.vue'
import AppearanceSettings from '../views/Settings/AppearanceSettings.vue'
import {
  doc,
  getDoc
} from '@firebase/firestore'

const childRoutes = (prop, mode) => [
  {
    path: '',
    name: prop + '.home-4',
    meta: { dark: mode, doctorAuth: true, name: 'Home 4' },
    component: Dashboard4
  },
  {
    path: '/profile',
    name: prop + '.profile',
    meta: { dark: mode, doctorAuth: true, patientAuth: true, name: 'profile' },
    component: ProfileView
  },
  {
    path: '/editprofile',
    name: prop + '.editProfile',
    meta: { dark: mode, doctorAuth: true, patientAuth: true, name: 'editProfile' },
    component: ProfileEdit
  },
  {
    path: '/settings',
    name: prop + '.settings',
    component: MainSettings,
    meta: { dark: mode, doctorAuth: true, patientAuth: true, name: 'settings' },
    children: [
      { path: '', redirect: '/settings/appearance' },
      {
        path: 'appearance',
        name: 'appearanceSettings',
        component: AppearanceSettings
      }
    ]
  },
  {
    path: '/settings/appearance',
    name: prop + '.appearanceSettings',
    meta: { dark: mode, doctorAuth: true, patientAuth: true, name: 'settings' },
    component: AppearanceSettings
  }
]

const appChildRoute = (prop, mode = false) => [
  {
    path: 'calendar',
    name: prop + '.calendar',
    meta: { dark: mode, doctorAuth: true, name: 'Calendar' },
    component: Calendar
  },
  {
    path: 'chat',
    name: prop + '.chat',
    meta: { dark: mode, doctorAuth: true, name: 'Chat' },
    component: ChatIndex
  },
  {
    path: 'charts',
    name: prop + '.charts',
    meta: { dark: mode, doctorAuth: true, patientAuth: true, name: 'Charts' },
    component: ChartPage
  },
  {
    path: 'email',
    name: prop + '.email',
    meta: { dark: mode, doctorAuth: true, patientAuth: true, name: 'Email' },
    component: EmailListing
  },
  {
    path: 'email-compose',
    name: prop + '.email.compose',
    meta: { dark: mode, doctorAuth: true, name: 'New Email' },
    component: EmailCompose
  }
]

const authChildRoutes = (prop, mode = false) => [
  {
    path: 'sign-in1',
    name: prop + '.sign-in1',
    meta: { dark: mode, doctorAuth: false },
    component: SignIn1
  },
  {
    path: 'sign-up1',
    name: prop + '.sign-up1',
    meta: { dark: mode, doctorAuth: false },
    component: SignUp1
  },
  {
    path: 'password-reset1',
    name: prop + '.password-reset1',
    meta: { dark: mode, doctorAuth: false },
    component: RecoverPassword1
  },
  {
    path: 'lock-screen1',
    name: prop + '.lock-screen1',
    meta: { dark: mode, doctorAuth: false },
    component: LockScreen1
  },
  {
    path: 'confirm-mail1',
    name: prop + '.confirm-mail1',
    meta: { dark: mode, doctorAuth: false },
    component: ConfirmMail1
  }
]

const defaultlayout = (prop, mode = false) => [
  {
    path: 'faq',
    name: prop + '.faq',
    meta: { dark: mode, doctorAuth: true, name: 'Faq' },
    component: FAQ
  }
]

const pagesChildRoutes = (prop, mode = false) => [
  {
    path: 'error/:code',
    name: prop + '.error',
    meta: { dark: mode, doctorAuth: true },
    component: ErrorPage
  },
  {
    path: 'coming-soon',
    name: prop + '.coming-soon',
    meta: { dark: mode, doctorAuth: true },
    component: ComingSoon
  },
  {
    path: 'maintenance',
    name: prop + '.maintenance',
    meta: { dark: mode, doctorAuth: true },
    component: Maintenance
  }
]
const patientChildRoute = (prop, mode = false) => [
  {
    path: 'profile',
    name: prop + '.profile',
    meta: { dark: mode, doctorAuth: true, name: 'Profile' },
    component: Profile
  },
  {
    path: 'add-patient',
    name: prop + '.addPatient',
    meta: { dark: mode, doctorAuth: true, name: 'Add Profile' },
    component: AddPatient
  },
  {
    path: 'patients-list',
    name: prop + '.list',
    meta: { dark: mode, doctorAuth: true, name: 'User List' },
    component: UserList
  },
  {
    path: ':uid',
    name: prop + '.patientDashboard',
    meta: { dark: mode, doctorAuth: true, name: 'Patient Dashboard' },
    component: PatientDashboard,
    props: true
  }
]

const adminHomechildRoutes = (prop, mode) => [
  {
    path: '',
    name: prop + '.home',
    meta: { dark: mode, adminAuth: true, name: 'Admin-Home' },
    component: AdminHome,
    children: [
      {
        path: '/db/:collection',
        name: prop + '.collection',
        meta: { dark: mode, adminAuth: true, name: 'Admin-Collection' },
        component: CollectionsView,
        props: true
      },
      {
        path: '/db/:collectionId/:docId',
        name: prop + '.document',
        meta: { dark: mode, adminAuth: true, name: 'Admin-Document' },
        component: DocumentDisplay,
        props: true
      }
    ]
  },
  {
    path: '/preorders',
    name: prop + '.preorders',
    meta: { dark: mode, adminAuth: true, name: 'preorder' },
    component: PreOrderSummary,
    redirect: { name: prop + '.preordersTable', params: { device: 'kneesleeve' } }, // Redirect using name and params
    children: [
      {
        path: 'kneesleeve', // Changed to relative path
        name: prop + '.preordersTable',
        meta: { dark: mode, adminAuth: true, name: 'Admin-Preorders-Table' },
        component: PreordersTable,
        props: true
      }
    ]
  },
  {
    path: '/preorders/kneesleeve/:id', // Changed to relative path
    name: prop + '.preorderDetail',
    meta: { dark: mode, adminAuth: true, name: 'Admin-Preorder-Detail' },
    component: PreorderDetail,
    props: true
  },
  {
    path: '/submissions/bugs',
    name: prop + '.bugSubmissions',
    meta: { dark: mode, adminAuth: true, name: 'Admin-Bug-Submissions' },
    component: BugsManagementMenu,
    children: [
      { path: '', redirect: '/submissions/bugs/board' },
      {
        path: 'board',
        name: prop + '.bugBoard',
        meta: { dark: mode, adminAuth: true, name: 'Admin-Bugs-Board' },
        component: BugSubmissions
      },
      {
        path: 'backlog',
        name: prop + '.bugBacklog',
        meta: { dark: mode, adminAuth: true, name: 'Admin-Bugs-Backlog' },
        component: BugsBacklog
      }
    ]
  },
  {
    path: '/submissions/feedback',
    name: prop + '.feedbackSubmissions',
    meta: { dark: mode, adminAuth: true, name: 'Admin-Feedback-Submissions' },
    component: FeedbackSubmissions
  }
]

const patientHomechildRoutes = (prop, mode) => [
  {
    path: '',
    name: prop + '.home',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Home' },
    component: PatientHome
  },
  {
    path: '/customer/preorders',
    name: prop + '.preorderSummary',
    meta: { dark: mode, patientAuth: true, name: 'Preorder-Summary' },
    component: KneeSleevePreordersSummary
  },
  {
    path: '/customer/preorders/:id',
    name: prop + '.preorderDetails',
    meta: { dark: mode, patientAuth: true, name: 'Preorder-Details' },
    component: KneeSleevePreorderDetails,
    props: true
  },
  {
    path: '/customer/preorders/kneesleeve',
    name: prop + '.kneeSleevePreorderForm',
    meta: { dark: mode, patientAuth: true, name: 'KneeSleeve-Preorder' },
    component: KneeSleevePreorderForm
  },
  {
    path: '/customer/preorders/cancel',
    name: prop + '.PreorderCancel',
    meta: { dark: mode, patientAuth: true, name: 'Preorder-Cancel' },
    component: KneeSleevePreorderForm
  },
  {
    path: '/bugReport',
    name: prop + '.bugReport',
    meta: { dark: mode, patientAuth: true, name: 'Bug-Report' },
    component: ReportBugs
  },
  {
    path: '/feedback',
    name: prop + '.feedback',
    meta: { dark: mode, patientAuth: true, name: 'feedback' },
    component: ProvideFeedbackForm
  },
  {
    path: '/patient/profile',
    name: prop + '.patientProfile',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Profile' },
    component: PatientProfile
  },
  {
    path: '/patient/profile/edit',
    name: prop + '.patientProfileEdit',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Profile-Edit' },
    component: PatientProfileEdit
  },
  {
    path: '/shopSessions',
    name: prop + '.shopSessions',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Shop-Sessions' },
    component: ShopSessions
  },
  {
    path: '/shopCoins',
    name: prop + '.shopCoins',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Shop-Coins' },
    component: ShopCoins
  },
  {
    path: '/shopCoins/createWallet',
    name: prop + '.createWallet',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Create-Wallet' },
    component: CreateWallet
  },
  {
    path: '/shopCoins/importWallet',
    name: prop + '.importWallet',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Import-Wallet' },
    component: ImportWallet
  },
  {
    path: '/shopCoins/exportWallet/:walletAddress',
    name: prop + '.exportWallet',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Export-Wallet' },
    component: ExportWallet,
    props: true
  },
  {
    path: '/shopDevices/request',
    name: prop + '.requestInvoice',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Request-Invoice' },
    component: RequestInvoiceForm
  },
  {
    path: '/shopDevices',
    name: prop + '.shopDevices',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Shop-Devices' },
    component: ShopDevices
  },
  {
    path: '/cart',
    name: prop + '.cart',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Shop-Cart' },
    component: ShoppingCart
  },
  {
    path: '/order/cancel',
    name: prop + '.orderCancel',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Order-Cancel' },
    component: ShoppingCart
  },
  {
    path: '/order/success/:sessionId',
    name: prop + '.orderSuccess',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Order-Success' },
    component: OrderComfirmation
  },
  {
    path: '/order/confirmation/:sessionId',
    name: prop + '.orderConfirmation',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Order-Confirmation' },
    component: OrderComfirmation
  },
  {
    path: '/orders',
    name: prop + '.orderHistory',
    meta: { dark: mode, patientAuth: true, name: 'Patient-Shop-Cart' },
    component: OrderHistory
  }
]

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Layout1,
    meta: { doctorAuth: true },
    children: childRoutes('dashboard')
  },
  {
    path: '/auth',
    name: 'auth1',
    component: AuthLayout1,
    meta: { doctorAuth: true },
    children: authChildRoutes('auth1')
  },
  {
    path: '/pages',
    name: 'pages',
    component: Default,
    meta: { doctorAuth: true },
    children: pagesChildRoutes('default')
  },
  {
    path: '/extra-pages',
    name: 'extra-pages',
    component: Layout1,
    meta: { doctorAuth: true },
    children: defaultlayout('extra-pages')
  },
  {
    path: '/app',
    name: 'app',
    component: Layout1,
    meta: { doctorAuth: true },
    children: appChildRoute('app')
  },
  {
    path: '/patients',
    name: 'patients',
    component: Layout1,
    meta: { doctorAuth: true },
    children: patientChildRoute('patients')
  },
  {
    path: '/patient-home',
    name: 'patient',
    component: Layout1,
    meta: { patientAuth: true },
    children: patientHomechildRoutes('patient')
  },
  {
    path: '/admin',
    name: 'admin',
    component: Layout1,
    meta: { adminAuth: true },
    children: adminHomechildRoutes('admin')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebaseProject.firebaseAuth.onAuthStateChanged(
      (user) => {
        unsubscribe()
        resolve(user)
      },
      reject
    )
  })
}

router.beforeEach(async (to, from) => {
  const currentUser = await getCurrentUser()

  if ((to.meta.doctorAuth && to.meta.patientAuth) || (to.meta.doctorAuth && to.meta.patientAuth && to.meta.adminAuth)) {
    if (currentUser == null) {
      return '/auth/sign-in1'
    } else {
      return
    }
  }
  if (to.meta.doctorAuth) {
    if (currentUser == null) {
      return '/auth/sign-in1'
    } else {
      const ref = doc(firebaseProject.db, 'doctors', currentUser.uid)
      const docSnapshot = await getDoc(ref)
      if (!docSnapshot.exists()) {
        const ref = doc(firebaseProject.db, 'users', currentUser.uid)
        const usersSnapshot = await getDoc(ref)
        if (!usersSnapshot.exists()) {
          return 'admin'
        }
        if (usersSnapshot.data().isAuthorized) {
          return '/patient-home'
        }
        return '/customer/preorders'
      }
    }
  }

  if (to.meta.patientAuth) {
    return
    if (currentUser == null) {
      return '/auth/sign-in1'
    } else {
      const patientRef = doc(firebaseProject.db, 'users', currentUser.uid)
      const patientSnapshot = await getDoc(patientRef)
      if (patientSnapshot.exists()) {
        return
      }
      const ref = doc(firebaseProject.db, 'doctors', currentUser.uid)
      const docSnapshot = await getDoc(ref)
      if (docSnapshot.exists()) {
        return '/'
      } else {
        return '/admin'
      }
    }
  }

  if (to.meta.adminAuth) {
    return
    if (currentUser == null) {
      return '/auth/sign-in1'
    } else {
      const ref = doc(firebaseProject.db, 'doctors', currentUser.uid)
      const docSnapshot = await getDoc(ref)
      if (docSnapshot.exists()) {
        return '/'
      } else {
        const ref = doc(firebaseProject.db, 'users', currentUser.uid)
        const usersSnapShot = await getDoc(ref)
        if (usersSnapShot.exists() && usersSnapShot.data().isAuthorized) {
          return '/patient-home'
        } else {
          return '/customer/preorders'
        }
      }
    }
  }
})

export default router
